import script from "./HeaderAccessGroupSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderAccessGroupSelect.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderAccessGroupSelect.vue?vue&type=style&index=0&id=727ea134&scoped=true&lang=scss"
import "./HeaderAccessGroupSelect.vue?vue&type=style&index=1&id=727ea134&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-727ea134"]])

export default __exports__